<template>
  <div>
    <dt class="theme-text-dark fw-bold fs-md mb-xs">{{ title }}</dt>
    <dd class="fs-sm theme-text-medium">{{ description }}</dd>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
  },
};
</script>
